<template>
  <section class="main-slider-section">
    <video v-if="!smDisplay" autoplay muted loop id="myVideo">
      <source src="/static-assets/img/fin_ura2.mp4" type="video/mp4">
    </video>
    <div v-bind:class="{'home-slider-bg': smDisplay}" class="main-slider-container">
      <div class="main-slider-wrapper swiper-wrapper">
        <div class="main-slide swiper-slide" >

          <div class="main-slide-content">
            <div class="container wow fadeInDown" data-wow-duration="2чs">
              <span v-bind="$parent.dKey('b1subtitle')" class="section-title">{{subtitle}}</span>
              <h1 v-bind="$parent.dKey('b1title')" v-html="title"></h1>
              <h2 v-bind="$parent.dKey('b1subtitleUnder')">{{downTitle}}</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="container slider-navigation wow fadeIn hidden" data-wow-duration="2s" data-wow-delay="1s">
        <div class="main-slider-prev-btn main-slider-btns"></div>
        <div class="main-slider-next-btn main-slider-btns"></div>
        <div class="main-slider-progress"></div>
        <div class="main-slider-numbers d-flex"><span class="slider-current">1</span>/<span class="slider-count"></span></div>
      </div>
    </div>
    <div class="company-logo wow fadeIn" data-wow-duration="2s" data-wow-delay="1.25s">
      <div>
        <img src="/static-assets/img/logo-company.png" alt="">
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'HomeSlider',

  data() {
    return {
      smDisplay: false
    }
  },

  props: ['title', 'subtitle', 'downTitle'],

  mounted() {

    let self = this

    this.smDisplay = $(window).width() < 1024

    $(window).resize(function(){
      self.smDisplay = $(window).width() < 1024;
    })

    document.querySelectorAll('[data-key]').forEach(function(node){
      node.contentEditable = true
    })

    if ($('.main-slider-container').length) {
      // var swiper = new Swiper('.main-slider-container', {
      //   pagination: {
      //     el: '.main-slider-progress',
      //     type: 'progressbar',
      //   },
      //   navigation: {
      //     nextEl: '.main-slider-next-btn',
      //     prevEl: '.main-slider-prev-btn',
      //   },
      // });

      //this code must be last
      // $('.slider-count').text(swiper.slides.length);

      // swiper.on('slideChange', function () {
      //   $('.slider-current').text(swiper.activeIndex + 1);
      // });
    }
  }
}

</script>

<style scoped>
  .home-slider-bg {
    background: url(/static-assets/img/0001.jpg) no-repeat;
    background-size: cover;
  }
</style>
